import { toast } from 'sonner';

import { useApiMutation, useApiQuery } from '@/modules/common';

import { EventDetails, EventUploadUrlData, UpdateEventPayload } from '../types';

export function useEventDetails(eventId: string) {
  const { data: uploadUrlData, refetch: refetchUploadUrl } =
    useApiQuery<EventUploadUrlData>(`/events/reupload-url/${eventId}`, {
      queryKey: ['eventDetailsUploadUrl'],
      initialData: null,
    });

  const { data: uploadIdleStateUrlData, refetch: refetchIdleStateUploadUrl } =
    useApiQuery<EventUploadUrlData>(
      `/events/idle-state-video-reupload-url/${eventId}`,
      {
        queryKey: ['eventDetailsIdleStateUploadUrl'],
        initialData: null,
      }
    );

  const { isFetching, data } = useApiQuery<EventDetails>(`/events/${eventId}`, {
    queryKey: ['eventDetails', String(eventId)],
    initialData: null,
  });

  const updateEventMutation = useApiMutation<UpdateEventPayload>(
    '/events',
    {
      method: 'PATCH',
    },
    {
      onError: (error) => {
        toast.error(
          `Uh oh! Something went wrong. ${error?.message?.slice(0, 50)}`
        );
      },
    }
  );

  return {
    isFetching,
    details: data,
    updateEventMutation,
    refetchUploadUrl,
    uploadUrlData: {
      ...uploadUrlData,
      idleStateVideoPublicUrl: uploadIdleStateUrlData?.signedUrl,
    },
    refetchIdleStateUploadUrl,
  } as const;
}
